var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const mergeRefs = /* @__PURE__ */ __name((refs) => (value) => {
  for (const ref of refs) {
    if (ref !== null && ref !== void 0) {
      if (typeof ref === "function") {
        ref(value);
      } else {
        ref.current = value;
      }
    }
  }
}, "mergeRefs");

export { mergeRefs };
//# sourceMappingURL=merge-refs.js.map
